import { Logo } from "./Logo";
import { resolveBrand, isBrandedNarrow } from "../lib/brand";

const BRAND_FOOTER = {
  soulumo: { copyright: "Soulumo", tagline: null },
  oml:     { copyright: "One Million Lights", tagline: null },
};

/**
 * Footer Branding Component
 * Subtle branding for the bottom of pages. Brand-aware so soulumo.app
 * / onemillionlights.org never reveal the Reclaim parent brand.
 */
export const FooterBranding = ({ className = "" }) => {
  const brand = resolveBrand();
  if (isBrandedNarrow(brand)) {
    const b = BRAND_FOOTER[brand] || { copyright: brand, tagline: null };
    return (
      <footer className={`py-8 text-center ${className}`}>
        <p className="text-xs text-[#78716C]">
          © {new Date().getFullYear()} {b.copyright}
        </p>
      </footer>
    );
  }
  return (
    <footer className={`py-8 text-center ${className}`}>
      <div className="flex flex-col items-center gap-3">
        <Logo size="sm" variant="dark" className="opacity-60" />
        <p className="text-xs text-[#78716C]">
          © {new Date().getFullYear()} Reclaim · School of Consciousness
        </p>
      </div>
    </footer>
  );
};

export default FooterBranding;
